<template>
    <el-container>
        <el-main>
            <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
                <el-row>
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="用户名" prop="userName" >
                            <el-input v-model="searchData.userName" placeholder="用户名" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="姓名" prop="realName" >
                            <el-input v-model="searchData.realName" placeholder="姓名" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="课名" prop="courseName" >
                            <el-input v-model="searchData.courseName" placeholder="课名" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="cls-col" v-if="orgType == 1">
                        <el-form-item label="组织机构" prop="orgCode">
                            <el-select
                                placeholder="组织机构"
                                clearable
                                size="small"
                                v-model="searchData.orgCode"
                                @change="changeLecturer"
                                style="margin-right: 10px; width: 100%"
                            >
                                <el-option
                                    v-for="o in org"
                                    :label="o.organizationName"
                                    :value="o.orgCode"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="来源" clearable prop="source">
                            <el-select
                                v-model="searchData.source"
                                clearable
                                placeholder="来源"
                                size="small"
                                @change="changeLecturer"
                                style="width: 100%"
                            >
                                <el-option label="已缴费学生" :value="32" ></el-option>
                                <el-option label="批量导入" :value="16"></el-option>
                                <el-option label="单个添加" :value="8"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                <el-col :span="5" class="cls-col">
                    <el-form-item label="批次" prop="banch" >
                        <el-select
                            placeholder="批次"
                            size="small"
                            clearable
                            v-model="searchData.banch"
                            :disabled="!isBanch"
                            style="margin-right: 10px; width: 100%"
                        >
                            <el-option v-for="banch in orgBanchList" :label="banch" :value="banch"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                </el-row>

                <el-form-item>
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        icon="el-icon-search"
                        @click="onSubmit()"
                    >查询</el-button>
                </el-form-item>
            </el-form>
            <el-button
                type="success"
                icon="el-icon-upload"
                size="small"
                round
                @click="allocateCourse"
                class="but-cls"
            >分配课程</el-button>
            <el-button
                type="danger"
                icon="el-icon-delete"
                size="small"
                round
                @click="deleteMore"
                class="but-cls"
            >删除</el-button>
            <el-table
                :data="staffData"
                border
                highlight-current-row
                v-loading="loading"
                style="width: 100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" label="序号" width="50" fixed="left"></el-table-column>
                <el-table-column prop="userName" label="用户名" width="200" fixed="left"></el-table-column>
                <el-table-column prop="orgName" label="组织机构" width="250"></el-table-column>
                <el-table-column prop="realName" label="姓名" width="100"></el-table-column>
                <el-table-column label="课程名称" width="250">
                    <template slot-scope="scope">
                        <div
                            v-for="courserModel in scope.row.courseList"
                        >{{courserModel.courseName}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="source" label="来源" width="200" :formatter="sourceFormat"></el-table-column>
                <el-table-column prop="banch" label="批次" width="200"></el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button
                            @click="updateStaff(scope.$index, scope.row)"
                            type="text"
                            size="small"
                        >修改课程</el-button>
                        <el-button
                            @click="deleteStaff(scope.$index, scope.row)"
                            type="text"
                            size="small"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                style="margin-top: 10px; float: right; margin-right: 10px"
            ></el-pagination>
        </el-main>
    </el-container>
</template>

<script>
import https from "@/https.js";
import validate from "@/api/validate.js";

const form = {};

export default {
    data() {
        return {
          user: '',
            headerData: {Authentication: localStorage.getItem("token")},
            org: [],
            orgType: "",
          loginOrgCode: '',
          isBanch: false,
          orgCode: '',
          orgBanchList: [],
          banchList: [],
            loading: true,
            form: JSON.parse(JSON.stringify(form)),
            searchData: {
                userName: "",
                realName: "",
                courseName: "",
                orgCode: "",
                source: "",
                banch: "",
                page: 1,
                size: 0,
            },
            multipleSelection: [],
            total: 0,
            pageSize: 10,
            currentPage: 1,
            addStaff: false,
            staffData: [],
            isUpdate: false,
            title: "添加用户",
            area: [],
            city: [],
            showImport: false,
            fileList: [],
            importStudentForm: {
                orgCode: "",
                banch: "",
                file: null,
            },
            uploadUrl: this.https.baseURL + "/managerStudent/importStudent",
            isShowChooseBtn: true,
        };
    },
    methods: {
        conformPassword(rule, value, callback) {
            if (this.form.password == value) {
                callback();
            } else {
                callback(new Error("两次密码输入不一致"));
            }
        },
        updateUserState(row) {
            if (row == undefined) {
                this.$message({
                    type: "info",
                    message: "操作失败",
                });
            }

            let params = {
                userName: row.userName,
                status: row.status,
            };
            this.https
                .fetchPost("/managerStudent/updateUserState", params, "json")
                .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });
                    } else {
                        this.$message({
                            type: "info",
                            message: "加载失败:" + msg,
                        });
                        if (row.status == 1) {
                            row.status = 2;
                        } else {
                            row.status = 1;
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$message.error("网络错误");
                    if (row.status == 1) {
                        row.status = 2;
                    } else {
                        row.status = 1;
                    }
                });
        },
        handleDialogClose() {
            let that = this;
            that.form = JSON.parse(JSON.stringify(form));
            that.addStaff = false;
            that.isUpdate = false;
            that.form.userId = "";
            that.$refs["staffForm"].clearValidate();
        },
        changeLecturer() {
          let orgCode = "";
          this.orgBanchList = [];
          this.searchData.banch = '';
          this.isBanch = false;
          if(this.searchData.source == 16) {
            this.isBanch = true;
          }
          if(this.searchData.orgCode && this.searchData.source == 16) {
            orgCode = this.searchData.orgCode;
          }
          if(this.orgType != 1 && this.searchData.source == 16) {
            orgCode = this.orgCode;
          }
          for(let banch of this.banchList) {
            if(banch.orgCode == orgCode) {
              this.orgBanchList = banch.banchList;
              return;
            }
          }
        },
        selectOrg() {
            https
                .fetchGet("/managerOrganization/getOrganizationList", "", "from")
                .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        this.org = data.data.data;
                    } else {
                        this.$message({
                            type: "info",
                            message: msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message.error("网络错误");
                });
        },
        handleSelectionChange(val) {
            this.multipleSelection = [];
            for (let index in val) {
                this.multipleSelection[index] = val[index].userName;
            }
        },        
        deleteMore() {
            let roleLength = this.multipleSelection.length;
            this.$confirm("此操作将删除" + roleLength + "条用户信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let multipleSelection = this.multipleSelection;
                    let params = {
                        userNameList: multipleSelection,
                    };
                    https
                        .fetchPost("/managerStudent/deleteStudentCourse", params, "json")
                        .then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if (code == "200") {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                                this.onSubmit();
                            } else {
                                this.$message({
                                    type: "info",
                                    message: "删除失败:" + msg,
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message.error("网络异常！");
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        deleteStaff(index, row) {
            this.$confirm("此操作将删除该用户信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let params = {
                        userNameList: [row.userName],
                    };
                    https
                        .fetchPost("/managerStudent/deleteStudentCourse", params, "json")
                        .then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if (code == "200") {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                                this.onSubmit();
                            } else {
                                this.$message({
                                    type: "info",
                                    message: "删除失败:" + msg,
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message.error("网络异常！");
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        onSubmit(val) {
            if (val) {
                this.searchData.page = val;
            } else {
                this.searchData.page = 1;
                this.currentPage = 1;
            }
            this.searchData.size = this.pageSize;
            let params = this.searchData;
            this.loading = true;
            https
                .fetchPost("/managerStudent/searchStudentCourse", JSON.parse(JSON.stringify(params)), "json")
                .then((data) => {
                    let code = data.data.code;
                    if (code == "200") {
                        this.staffData = data.data.data;
                        this.total = data.data.total;
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$message.error("数据加载失败");
                });
        },
        handleSizeChange() {},
        handleCurrentChange(val) {
            this.onSubmit(val);
        },
        updateStaff(index, row) {
            this.title = "修改课程";
            this.form = JSON.parse(JSON.stringify(row));
            this.$router.push({name:'modifyCourse',params:{userModel:row}});
        },
        saveStaff(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.$message.error("请正确填写信息！");
                    return false;
                } else {
                    let url = "/managerStudent/addUser";
                    if (this.form.userId) {
                        url = "/managerStudent/updateUser";
                    }
                    let params = this.form;
                    https
                        .fetchPost(url, params)
                        .then((data) => {
                            console.log(data);
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if (code == "200") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                });
                                this.addStaff = false;
                                this.isUpdate = false;
                                this.onSubmit();
                                this.form = JSON.parse(JSON.stringify(form));
                            } else {
                                this.$message.error("操作失败:" + msg);
                            }
                        })
                        .catch((err) => {
                            this.$message.error("网络错误");
                        });
                }
            });
        },
        staffStatus(row, column, cellValue, index) {
            if (cellValue == 1) {
                //（1 正常，2停用，3锁定）
                return "正常";
            }
            if (cellValue == 2) {
                return "停用";
            }
            if (cellValue == 2) {
                return "锁定";
            }
            return "其他";
        },
        staffSex(row, column, cellValue, index) {
            if (cellValue == 1) {
                //（性别(0 未知；1女；2男)
                return "女";
            }
            if (cellValue == 2) {
                return "男";
            }

            return "未知";
        },
        searchArea() {
            https
                .fetchGet("/managerAreas/getAreaTree", "", "form")
                .then((data) => {
                    let code = data.data.code;
                    if (code == "200") {
                        this.area = data.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$message.error("数据加载失败");
                });
        },
        changeOrgAdd(val) {},
        changeProvince(val) {
            this.city = [];
            let nowProvince = this.area.find((t) => t.code == val);
            this.city = nowProvince.children;
        },
        handleStudentClose() {
            let that = this;
            that.importStudentForm = importStudentForm;
            that.showImport = false;
            that.$refs["importStudentForm"].clearValidate();
        },
        sourceFormat(row, column, cellValue, index) {
            if (cellValue != null) {
                let result = "";
                switch (cellValue) {
                    case 16:
                        result = "批量导入";
                        break;
                    case 8:
                        result = "单个添加";
                        break;
                    case 1:
                        result = "用户注册";
                        break;
                    case 2:
                        result = "用户注册";
                        break;
                    case 32:
                        result = "已缴费学生";
                        break;
                }
                return result;
            } else {
                return cellValue;
            }
        },       
        allocateCourse() {
            this.$router.push('/StudentCourse/AllocateCourse');
        },
      selectBanch() {
        let params = {
          orgCode: "",
          source: "",
        };
        https.fetchPost("/managerStudent/getBanchList", params, "json").then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            if(data.data.data) {
              this.banchList = data.data.data;
            }
          } else {
            this.$message({
              type: "info",
              message: "加载失败:" + msg,
            });
          }
        })
            .catch((err) => {
              console.log(err);
              this.$message.error("网络错误");
            });
      },
    },
    created: function() {
        this.orgType = this.$store.state.orgType;
        this.orgCode = this.$store.state.orgCode;
        this.loginOrgCode = this.$store.state.orgCode;
        this.user = this.$store.state.user;
        this.onSubmit();
        this.searchArea();
        this.selectOrg();
        this.selectBanch();
    },
};
</script>

<style scoped>
.but-cls {
    margin-bottom: 10px;
}
.cls-col {
    margin-right: 20px;
}
</style>
